/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */
import type { ChallengeNameType } from './challengeNameType'
import type { User } from './user'

export type SignInOutPutAllOf = {
  user: User
  challengeName: ChallengeNameType
  session: string
}
